import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api.constant';
import { ApiResponse, Role } from '../models/api-response.model';

export type RolePayload = Pick<Role, 'name' | 'description'>;

@Injectable({ providedIn: 'root' })
export class RoleManagementService {
  private readonly http = inject(HttpClient);

  list(): Observable<ApiResponse<Role[]>> {
    return this.http.get<ApiResponse<Role[]>>(API_ENDPOINTS.roles);
  }

  create(payload: RolePayload): Observable<ApiResponse<Role>> {
    return this.http.post<ApiResponse<Role>>(API_ENDPOINTS.roles, payload);
  }
}
